import { hexColor, Show, Text, View } from "@lightningtv/solid";
import { t } from "../../translations/configuration";

const ProxyHealthMessage = (props: any) => {

    return (
        <Show when={props.isProxyHealthDialogOpen()}>
            <View x={500} y={980} width={900} height={60} color={hexColor("#4b494980")} borderRadius={20}>
                <Text x={70} y={20} style={{ fontSize: 24, color: hexColor("#ffffff"), fontWeight: "normal" }}>
                    {t("proxyMaintenanceMessage")}
                </Text>
            </View>
        </Show>
    );
};

export default ProxyHealthMessage;